import React, { useState } from "react";
import axios from "axios";
import { FiDownload } from "react-icons/fi";
import { translate } from "reducers/i18n";
import settings from "client.settings.json";

export const DownloadAllButton = ({ messageId, tenantId, tokens }) => {
  const [isExporting, setIsExporting] = useState(false);
  const downloadAll = async () => {
    try {
      setIsExporting(true);
      const token = tokens.zip;
      const a = document.createElement("a");
      a.href = `${settings.api}/download/${token}`;
      a.setAttribute("download", "");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setIsExporting(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <div className="">
        <button
          tabIndex="0"
          className="button"
          title=""
          onClick={downloadAll}
          style={{ outline: "none" }}
          disabled={isExporting}
        >
          <FiDownload /> {isExporting ? "Generating" : translate("compose_download_copy_with_attachments")}
        </button>
      </div>
    </div>
  );
};
